import * as React from "react";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import "../../style/common/style.scss";
import { InputAdornment, Button, DialogActions } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import moment from "moment/moment";
import dayjs from "dayjs";
export default function CustomDatePicker(props) {
  const [value, setValue] = React.useState(null);
  const {
    label,
    selectedDate,
    onChange,
    maxDate = "",
    minDate = moment(window.getTime ? window.getTime() : new Date()).format("YYYY-MM-DD"),
    disabled = false,
    onKeyDown,
    id,
    dateArray = [0, 1, 2, 3, 4, 5, 6],
  } = props;
  const [isOpen, setIsOpen] = React.useState(false);
  React.useEffect(() => {
    if (selectedDate) setValue(selectedDate);
    else setValue(null);
  }, [selectedDate]);
  const handleOnChange = (newValue) => {
    setValue(newValue);
    onChange(newValue);
  };
  const handleKeyDown = (e) => {
    // Check if the key pressed is the spacebar (keyCode 32)
    if (e.keyCode === 32) {
      !disabled && setIsOpen(true); // Open date picker on spacebar press
    } else {
      // If not spacebar, trigger the provided onKeyDown event handler
      onKeyDown && onKeyDown(e);
    }
  };
  const isDateDisabled = (date) => {
    if (dateArray.length > 0) {
        const dayOfWeek = dayjs(date).day();
        return !dateArray.includes(dayOfWeek);
    }
    return false;
};



  const CustomActionBar = (props) => (
    <DialogActions style={{ display: 'flex', justifyContent: 'flex-end', padding: '10px' }}>
      <span
        style={{
          cursor: 'pointer',
          marginTop: 'auto',
          marginBottom: '10px',
        }}
        onClick={() => {
          handleOnChange(dayjs(window.getTime ? window.getTime() : new Date()).toDate())
          setIsOpen(false)
        }}
      >
        Today's Date : <span style={{ fontWeight: '600' }}>
          {dayjs(window.getTime ? window.getTime() : new Date()).format('DD-MM-YYYY')}
        </span>
      </span>
    </DialogActions>
  );

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        value={value}
        inputFormat="DD-MMM-YYYY"
        className="datePicker"
        onChange={handleOnChange}
        maxDate={maxDate}
        minDate={minDate}
        open={isOpen}
        disabled={disabled}
        onClose={() => setIsOpen(false)}
        components={{ ActionBar: CustomActionBar }}
        renderInput={(params) => (
          <TextField
            {...params}
            inputProps={{ ...params.inputProps, readOnly: true }}
            sx={{
              width: "100%",
              "& label.Mui-focused": {
                color: "#004F9E !important", // change this to the desired color
              },
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: isOpen ? "#004F9E" : "#a6a8ab",
                },
                "&:hover fieldset": {
                  borderColor: isOpen ? "#004F9E" : "#a6a8ab",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#004F9E",
                },
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <CalendarTodayIcon />
                </InputAdornment>
              ),
            }}
            onClick={() => !disabled && setIsOpen(true)}
            InputLabelProps={{
              style: { color: isOpen ? "#004F9E" : "#666666" },
            }}
            // onKeyDown={(e) => {
            //   onKeyDown && onKeyDown(e);
            // }}
            onKeyDown={handleKeyDown}
            id={id}
          />
        )}
        shouldDisableDate={isDateDisabled}
      />
    </LocalizationProvider>
  );
}